export default "__VITE_ASSET__D6sy8Lzt__"